import axiosInstance from "~/shared/api/axios-instance";
import { toValidUntil } from "../lib/to-valid-until";

export const updateBranchVersion = async (params: {
  branchUid: string;
  branchVersionId: number;
  name: string;
  description: string;
  validFrom: string;
  validTo: string;
}) => {
  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/versions/${params.branchVersionId}/`,
    {
      name: params.name,
      description: params.description,
      valid_from: params.validFrom || null,
      valid_until: toValidUntil(params.validTo),
    },
  );
  return data;
};

export const updateBranchVersionActive = async (params: {
  branchUid: string;
  branchVersionId: number;
  isActive: boolean;
}) => {
  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/versions/${params.branchVersionId}/`,
    {
      is_active: params.isActive,
    },
  );
  return data;
};
